import React from 'react'
import { motion } from 'framer-motion'

interface CollapseProps {
    pose: string
    className?: string
    children?: React.ReactNode
    initial?: string
}

const collapseVariant = {
    open: {
        opacity: 1,
        height: 'auto'
    },
    collapsed: {
        opacity: 0,
        height: 0
    }
}

const Collapse: React.FC<CollapseProps> = ({
    pose,
    className,
    children,
    initial = 'collapsed',
    ...additionalProps
}) => {
    return (
        <motion.div
            initial={initial}
            transition={{ linear: 'linear' }}
            variants={collapseVariant}
            animate={pose}
            className={className}
            {...additionalProps}
        >
            {children}
        </motion.div>
    )
}

export { Collapse }
